import { PopularCountries } from './PopularCountries';

export default PopularCountries;
